export default __webpack_public_path__ + "static/sticksports-5d6d480be0f19401cef80f8b34bc25c7.png";